// @module NVT.MyRegisterColleague.MyPromotion
define('NVT.MyRegisterColleague.MyPromotion.View'
,	[
		'nvt_promotion.tpl'
		
	,	'Backbone'

	,	'NVT.MyRegisterColleague.MyRegisterColleague.SS2Model'

    ]
, function (
		nvt_promotion_tpl
		
	,	Backbone

	,	MyRegisterColleagueSS2Model

)
{
    'use strict';

	// @class NVT.MyRegisterColleague.MyPromotion.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_promotion_tpl

	,	initialize: function (options) {

			this.options = options;
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.pdp = this.container.getComponent('PDP');
			var getskucode = this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.internalid : ''
			var self = this;
			this.model = new MyRegisterColleagueSS2Model();
			if(getskucode){
				this.model.fetch({async: false,data: {
					'getmethod':'getPromotionList',
					'getskucode':getskucode
				},
				}).done(function(result) {
					if(result.length > 0){
						self.message = result;
						self.render();
					}
				});
			}
		}

	,	bindings: {

		}

	, 	childViews: {

		}

		//@method getContext @return NVT.MyRegisterColleague.MyPromotion.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			this.message = this.message || [];
			
			return {
				iscoupon : this.message.length > 0,
				cuponname : this.message.length > 0 ? this.message[0].name	: '',
				cuponcode : this.message.length > 0 ? this.message[0].code	: '',
				cupondescription : this.message.length > 0 ? this.message[0].description : ''
			};
		}
	});
});
